import { Api } from '@/services/apiService';

class vesselTypesVR {
    static index() {
        return Api.get('/pact/vessel/type');
    }
}

export default vesselTypesVR;
